export const ENV = {
  isDev: import.meta.env.VITE_ENVIRONMENT === 'development' || import.meta.env.VITE_ENVIRONMENT === 'test',
  isStage: import.meta.env.VITE_ENVIRONMENT === 'stage',
  isProd: import.meta.env.VITE_ENVIRONMENT === 'production',
  current: import.meta.env.VITE_ENVIRONMENT as string,
};

export const Config = {
  appName: import.meta.env.VITE_APP_NAME as string,
  appVersion: import.meta.env.VITE_APP_VERSION || '0.0.1',
  releaseVersion: import.meta.env.VITE_APP_VERSION || '0.0.1',
  graphqlEndpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT as string,
  adminGraphqlEndpoint: import.meta.env.VITE_ADMIN_GRAPHQL_ENDPOINT as string,
  // Base URL of the public registration page invite recipients use to accept an
  // invite (e.g. https://worksuite.silverfern.red). When set, the invites grid
  // renders a full acceptance URL; otherwise it falls back to copying the raw code.
  inviteRegistrationBaseUrl: import.meta.env.VITE_INVITE_REGISTRATION_BASE_URL as string | undefined,
  forgeTaskUrlBase: import.meta.env.VITE_FORGE_TASK_URL_BASE as string | undefined,
  auth: {
    provider: import.meta.env.VITE_AUTH_PROVIDER as 'okta' | 'fusionauth',
    // OIDC-only base URL (authorize / token / userinfo / logout). Legacy sf-auth REST
    // endpoints (/sf/manage/companies, /sf/sa/me/*) were removed; any admin data now
    // lives behind `adminGraphqlEndpoint` so FusionAuth admin secrets never reach the PWA.
    url: import.meta.env.VITE_AUTH_URL as string,
    clientId: import.meta.env.VITE_CLIENT_ID as string,
    tenantId: import.meta.env.VITE_TENANT_ID as string | undefined,
  },
  tokenDuration: 3600,
  features: {
    enableSentry: import.meta.env.VITE_ENABLE_SENTRY === 'true',
    enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
    sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
    enableWebVitals: import.meta.env.VITE_ENABLE_WEB_VITALS !== 'false', // Enabled by default
    webVitalsDevOverlay: import.meta.env.VITE_WEB_VITALS_DEV_OVERLAY !== 'false', // Enabled by default in dev
  },
};

// Validate required environment variables
export const validateEnvironment = () => {
  const requiredEnvVars = [
    'VITE_GRAPHQL_ENDPOINT',
    'VITE_AUTH_PROVIDER',
    'VITE_AUTH_URL',
    'VITE_CLIENT_ID',
  ];

  const missing = requiredEnvVars.filter((key) => !import.meta.env[key]);

  if (missing.length > 0) {
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }
};